module.exports = __webpack_public_path__ + "static/media/agios.cfa48f3d.png";